let websocketInstance = null;

export function getWebSocketInstance(url, accessToken) {
  if (!websocketInstance || websocketInstance.readyState === WebSocket.CLOSED) {
    websocketInstance = new WebSocket(`${url}/notify/?token=${accessToken}`);

    websocketInstance.onopen = () => {};

    websocketInstance.onclose = () => {
      console.log("WebSocket closed");
      websocketInstance = null;
    };

    websocketInstance.onerror = (error) => {
      console.error("WebSocket error:", error);
    };
  }

  return websocketInstance;
}
